import axios from 'axios'
import {
  store
} from '../store/store'

const baseDomain = process.env.ROOT_API
// const baseDomain = 'http://localhost:85/'
const baseURL = `${baseDomain}`
export const Repository = axios.create({
  baseURL,
  crossDomain: false
})

Repository.interceptors.response.use(undefined, function (err) {
  return new Promise((resolve, reject) => {
    if (!err.response) {
      console.log('err Repository js', err)
      let response = {
        data: 'Network Error'
      }
      err.response = response
    }
    if (err.response.status === 401 && err.response.config && !err.response.config.__isRetryRequest) {
      // if you ever get an unauthorized, logout the user
      console.log('err Repository js 401', err)
      store.dispatch('USER_LOGOUT')
      // you can also redirect to /login if needed !
    }
    throw err
  })
})



// WEBPACK FOOTER //
// ./src/repositories/Repository.js